import { MyQuotationData } from '../../models/Quotations';

const useMyQuotations = () => {
    const createData = (
        quoteID: string,
        orderDate: string,
        count: number,
        status: string
    ): MyQuotationData => {
        return {
            quoteID,
            orderDate,
            count,
            status
        };
    };
    const getQuotations = () => {
        return [
            createData('122232222', '2021.12.20', 3, 'fizetve'),
            createData('12223222244', '2021.12.20', 2, 'kiküldve'),
        ];
    };

    const copyQuotation = (quoteId) => {};

    const deleteQuotation = (quoteId) => {};

    const createPDFQuotation = (quote) => {};

    const fakePromise = () => {
        return new Promise(function (resolve, reject) {
            resolve(true);
        });
    };

    return {
        getQuotations,
        copyQuotation,
        deleteQuotation,
        createPDFQuotation,
        fakePromise
    };
};

export default useMyQuotations;
